import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { get, postWithHeadersResponse } from "../../../server/actions";

let schoolId = 0; 

class EligibilityCodes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            mainFields: [],
            schoolName: ''
        };
    }

    componentDidMount() {
         if(sessionStorage.getItem('ROLE')==='ROLE_SUPERADMIN'){
            schoolId=this.props.school._links.self.href.split('/').pop();
            this.setState({schoolName:'['+this.props.school.schoolName+']'})
        }
        else{
            schoolId=sessionStorage.getItem('SchoolId');
        }
        this.getDataEligibilityCodesMap();
        this._notificationSystem = this.refs.notificationSystem;
    }

    // 🔹 Fetch Eligibility Codes
   getDataEligibilityCodesMap = () => {
        this.setState({ loading: true });

        get('/eligibilityCodes/?schoolId=' + schoolId + '&access_token=')
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then(data => {
                console.log('API Response:', data);

                let mappedFields = [];
                let currentMappingObj = {};

                // Extract codeMapping from currentMapping if it exists
                if (data.currentMapping && data.currentMapping.codeMapping) {
                    currentMappingObj = data.currentMapping.codeMapping;
                }

                // Map defaultCodes and use currentMapping codes where available
                if (data.defaultCodes && data.defaultCodes.length > 0) {
                    mappedFields = data.defaultCodes.map(item => {
                        // Look up custom code from currentMapping by codeDesc
                        const customCode = currentMappingObj[item.codeDesc] || item.code || '';
                        
                        return {
                            eligCodeId: item.eligCodeId,
                            codeDesc: item.codeDesc,
                            code: customCode, // Use mapped code if exists, else default code
                            defaultCode: item.code || '' // Keep default for reference
                        };
                    });
                }

                this.setState({
                    mainFields: mappedFields,
                    loading: false
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.log('Error fetching eligibility codes:', error);
            });
        };

// 🔹 Handle Code Change
 handleCodeChange = (index, value) => {
        let updatedFields = [...this.state.mainFields];
        updatedFields[index].code = value;

        this.setState({
            mainFields: updatedFields
        });
    };

  // 🔹 Save Mapping
  onSaveSubmit = () => {
     // Prevent duplicate codes (optional but recommended)
    let codes = this.state.mainFields.map(f => f.code.trim());
    let hasDuplicates = codes.some((code, i) =>
        codes.indexOf(code) !== i && code !== ''
    );

    if (hasDuplicates) {
        _addNotificationError('Duplicate codes are not allowed.', this);
        return;
    }

    this.setState({ loading: true });

     let codeMappingObj = {};

    this.state.mainFields.forEach(item => {
        if (item.code && item.code.trim() !== '') {
            codeMappingObj[item.codeDesc] = item.code.trim();
        }
    });

    let payload = {
        schoolId: schoolId,
        codeMapping: codeMappingObj
    };

    let headers = {
        'Content-Type': 'application/json'
    };

    postWithHeadersResponse(
        '/eligibilityCode/mapping?access_token=',
        JSON.stringify(payload),
        headers
    )
        .then((response) => {
            if (response.statusCode !== 200) {
                throw Error(response.statusMessage);
            }
            return response;
        })
        .then(res => {
            this.setState({ loading: false });
            _addNotification(res.statusMessage || 'Settings saved successfully.', this);
            this.getDataEligibilityCodesMap(); // Refresh data after saving
        })
        .catch(error => {
            this.setState({ loading: false });
            _addNotificationError(error.message, this);
        });
};

    render() {

        return (
            <section className="full-width clearfix margin-top">
                <NotificationSystem ref="notificationSystem" />
                <div
                    className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}
                >
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>

                <div className="col-xs-8 text-center createmenu-panel" style={{ margin: '0 auto', float: 'none' }}>
                    <div className="panel panel-primary">

                        <div className="panel-heading text-center">
                            <h3 className="panel-title">
                                Eligibility Code Settings
                            </h3>
                        </div>

                        <div className="panel-body">

                            <div className="alert alert-info text-left">
                                Map your eligibility codes to MealManage programs.
                                You may update codes as needed. Programs list cannot be modified.
                                You can save at any time.
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "40%", textAlign: "center" }}>Program Name</th>
                                            <th style={{ width: "40%", textAlign: "center" }}>Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.mainFields.length > 0 ? (
                                            this.state.mainFields.map((field, index) => (
                                                <tr key={field.eligCodeId}>
                                                    <td>
                                                        {field.codeDesc}
                                                    </td>
                                                    <td>
                                                         <input
                                                            type="text"
                                                            className="form-control"
                                                            value={field.code}
                                                            maxLength={10}
                                                            onChange={(e) =>
                                                                this.handleCodeChange(index, e.target.value)
                                                            }
                                                            placeholder="Enter Code"
                                                            style={{ width: '50%', margin: '0 auto' }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    No Programs Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="text-right">
                                <button
                                    className="btn btn-primary"
                                    onClick={this.onSaveSubmit}
                                >
                                    Save
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

            </section>
        );
    }
}

export default EligibilityCodes;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/eligibilityCodeSettings/index.jsx